/** View-only lifecycle grouping. Never authorizes or executes approvals. */
export type RequestOutcome = 'pending' | 'completed' | 'rejected';
export function requestOutcome(request: any): RequestOutcome {
    if (request.status === 'R' || ['level_1', 'level_2', 'level_3'].some(key => request[key] === 'R')) return 'rejected';
    // A retry or LDAP application can remain pending even after stage approval.
    if (request.status === 'D' || request.status === 'N') return 'pending';
    if (request.status === 'Y') return 'completed';
    if (!request.status && request.level_3 === 'Y') return 'completed';
    return 'pending';
}

export class RequestList {
    public scope: 'pending' | 'history' = 'pending';
    public filter: 'all' | 'completed' | 'rejected' = 'all';
    public pendingCount = 0;
    public historyCount = 0;
    public total = 0;
    public rows: any[] = [];
    public page = 1;
    public end = 1;
    public start = 1;
    private source: any[] = [];
    private pages: Record<string, number> = {};
    public outcome = requestOutcome;
    private urlPath = '';
    constructor(private urlKey = '') {
        if (!urlKey || typeof window === 'undefined') return;
        const url = new URL(window.location.href);
        this.urlPath = url.pathname;
        const params = url.searchParams;
        if (params.get(urlKey + '_scope') === 'history') this.scope = 'history';
        const filter = params.get(urlKey + '_filter');
        if (filter === 'completed' || filter === 'rejected') this.filter = filter;
        const page = Number(params.get(urlKey + '_page'));
        if (Number.isSafeInteger(page) && page > 0) this.pages[this.key] = page;
    }
    private saveLocation() {
        if (!this.urlKey || typeof window === 'undefined') return;
        const url = new URL(window.location.href);
        if (url.pathname !== this.urlPath) return;
        url.searchParams.set(this.urlKey + '_scope', this.scope);
        url.searchParams.set(this.urlKey + '_filter', this.filter);
        url.searchParams.set(this.urlKey + '_page', String(this.page));
        window.history.replaceState(window.history.state, '', url);
    }
    private get key() { return this.scope === 'pending' ? 'pending' : 'history-' + this.filter; }
    public setRows(rows: any[]) {
        this.source = rows;
        this.pendingCount = rows.filter(row => requestOutcome(row) === 'pending').length;
        this.historyCount = rows.length - this.pendingCount;
        this.refresh();
    }
    public setScope(scope: 'pending' | 'history') { this.scope = scope; this.refresh(); }
    public setFilter(filter: 'all' | 'completed' | 'rejected') { this.filter = filter; this.refresh(); }
    public changePage(page: number) {
        if (!Number.isInteger(page) || page < 1 || page > this.end) return;
        this.pages[this.key] = page;
        this.refresh();
    }
    private refresh() {
        const rows = this.source.filter(row => {
            const outcome = requestOutcome(row);
            return this.scope === 'pending' ? outcome === 'pending' : outcome !== 'pending' && (this.filter === 'all' || outcome === this.filter);
        });
        this.total = rows.length;
        this.end = Math.max(1, Math.ceil(rows.length / 10));
        this.page = Math.min(this.pages[this.key] || 1, this.end);
        this.pages[this.key] = this.page;
        this.start = Math.floor((this.page - 1) / 10) * 10 + 1;
        this.rows = rows.slice((this.page - 1) * 10, this.page * 10);
        this.saveLocation();
    }
}
